<template>
  <div class="yhc-component YhcSwitch" :class="parentClass">
    <PrivateLabel v-if="label" :labelClass="labelClass" :label="label"></PrivateLabel>

    <div class="content">
      <el-switch @change="$_change" v-model="result"></el-switch>
      <!-- 这个组件的尾部比较特殊，不用那个组件了 -->
      <span class="page-endLabel" v-if="endLabel" :style="endLabelStyle" @click="tapEndLabel">
        {{ endLabel }}
      </span>
    </div>
  </div>
</template>

<script>
import propsMixin from './componentsData/propsMixin';
import methodsMixin from './componentsData/methodsMixin';
import methodsMixin3 from './componentsData/methodsMixin3';

import PrivateLabel from './componentsData/PrivateLabel.vue';

let identifierName = 'YhcSwitch';

export default {
  name: identifierName,

  components: { PrivateLabel },
  mixins: [propsMixin, methodsMixin, methodsMixin3],

  data() {
    return {
      result: this.value,
    };
  },

  props: {
    value: {
      type: [String, Boolean],
    },
  },

  computed: {},

  watch: {
    value(newVal, oldVal) {
      this.result = newVal;
    },
  },

  methods: {
    tapEndLabel() {
      this.$emit('tapEndLabel', this.result, this.index, this.endLabel);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import './componentsData/labelComponentCommonStyle';
.YhcSwitch {
  @include labelCommon();
  @media screen and (max-width: 700px) {
    .page-endLabel {
      display: none;
    }
  }
}
</style>
